module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAbFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8+T+BWAAAAI3RSTlMAwOSxd4D7XPRwaTom68/Dp596cUsNBgG4lY5YVEQzMhwaEGHuy6EAAACOSURBVDjL3dLJDsMgDEXRl9ACBTI2SefR//+P3VCUhfGuUpq7QzpiYRsLbSgpl26niEoSMhGR1GZ1yDYqdeVRZQ5AamKRDbh3RerCoh5ez557Fj2gqHkZGb1RU4/x+9uORR4dVU6RiE54xrMQEA0YzTbleaTPYT6o7FpsmXILuYLfolpCt4hCW+Q6OvxzH3P0W/ztXnvlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w1_h.png
// module id = snTW
// module chunks = 1